/**
 * i18n bootstrap — react-i18next with in-bundle CZ + EN translations.
 *
 * Call once in main.tsx before rendering.
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import cs from "./locales/cs.json";
import en from "./locales/en.json";

const STORAGE_KEY = "rentier.lang";

const saved = typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

void i18n.use(initReactI18next).init({
  resources: {
    cs: { translation: cs },
    en: { translation: en },
  },
  lng: saved ?? "cs",
  fallbackLng: "cs",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  } catch {
    /* ignore */
  }
});

export { i18n };
export const SUPPORTED_LANGS = ["cs", "en"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export const LANGUAGE_LABELS: Record<SupportedLang, string> = {
  cs: "Čeština",
  en: "English",
};
